import { NOTIFICATIONS_ROUTE } from './../../_consts/notifications-panel.route.const';
export const NOTIFICATION_FORM_ROUTE = NOTIFICATIONS_ROUTE + '/dodaj';
